import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as z from 'zod';

const socialEventPolicySchema = (intl) =>
  z.object({
    socialEventPolicyAccepted: z.boolean().refine((val) => val === true, {
      message: intl.formatMessage({
        id: 'social_event_policy_form.accept_policy',
        defaultMessage: 'Please accept the Social Event Policy.'
      })
    })
  });

export const useSocialEventPolicyForm = (intl) => {
  const socialEventPolicyForm = useForm({
    resolver: zodResolver(socialEventPolicySchema(intl)),
    defaultValues: {
      socialEventPolicyAccepted: false
    }
  });

  return { socialEventPolicyForm };
};
